import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

type NetworkErrorMeta = ValueMeta<string> & {
  description: string;
  message: string;
};

export const NETWORK_ERROR_META = [
  {
    id: "NE01",
    name: "NETWORK_ERROR",
    label: "네트워크 오류",
    value: "NETWORK_ERROR",
    description: "서버 연결 실패 또는 네트워크 단절",
    message: "네트워크 연결에 문제가 발생했습니다. 인터넷 연결을 확인한 후 다시 시도해 주세요.",
  },
  {
    id: "NE02",
    name: "TIMEOUT",
    label: "요청 시간 초과",
    value: "TIMEOUT",
    description: "서버 응답 대기 시간 초과",
    message: "서버 응답 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요.",
  },
  {
    id: "NE03",
    name: "CONNECTION_FAILED",
    label: "서버 연결 실패",
    value: "CONNECTION_FAILED",
    description: "서버에 연결할 수 없음",
    message: "서버에 연결할 수 없습니다. 네트워크 상태를 확인해 주세요.",
  },
  {
    id: "NE04",
    name: "WEBSOCKET_CLOSED",
    label: "연결 종료",
    value: "WEBSOCKET_CLOSED",
    description: "WebSocket 연결이 예기치 않게 종료됨",
    message: "서버와의 연결이 끊어졌습니다. 자동으로 재연결을 시도합니다.",
  },
] as const satisfies readonly NetworkErrorMeta[];

export const NETWORK_ERROR_VALUE = metaToConsts(NETWORK_ERROR_META);
export const NETWORK_ERROR_MAP = metaToMap(NETWORK_ERROR_META);
export type NetworkErrorId = (typeof NETWORK_ERROR_META)[number]["id"];
